const header = window.RB_HEADER;

export function initMobileHeader() {
    const root           = header.mobile;
    const searchBtn      = root.querySelector('.-top-button.for--search');
    const menuBtn        = root.querySelector('.-top-button.for--menu');
    const bottom         = root.querySelector('.-bottom');
    const mainMenu       = bottom.querySelector('.-mainMenu');
    const search         = bottom.querySelector('.-search');
    const loginToggler   = root.querySelector('.is--login .-action-button');
    const login          = document.querySelector('[data-block="Login"]');
    const sidebarHeader  = root.querySelector('.sidebarHeader');
    const sidebarToggler = sidebarHeader.querySelector('.-toggler');
    const sidebar        = document.querySelector('.infoArticles-sidebar');
    const loginEl        = document.querySelector('[data-block="Login"]');

    let searchOpen      = false;
    let menuOpen        = false;
    let loginOpen       = false;
    let hidden          = false;
    let autohideAF      = null;
    let prevPageYOffset = null;

    if (header.getCurrent() === root) {
        initAutoHide();
    }
    initNestedMenu();
    menuBtn.addEventListener('click', toggleMenu);
    searchBtn.addEventListener('click', toggleSearch);
    sidebarToggler.addEventListener('click', toggleSidebar);
    document.addEventListener('rb.header.switch', () => {
        hideMenu();
        hideSearch();
        header.getCurrent() === root ? initAutoHide() : haltAutoHide();
    });

    function initNestedMenu() {
        const entries = [].slice.apply(mainMenu.querySelectorAll('.-entry.has--dropdown')).map(entry => {
            const button   = entry.querySelector('.-entry-link'),
                  submenu  = entry.querySelector('.-entry-submenu'),
                  // mainLink = submenu.querySelector('.-mainLink'),
                  sections = initSections();

            let isOpen = false;

            button.addEventListener('click', toggle);
            if (entry.classList.contains('is--ancestor')) {
                open();
            }

            function toggle() {
                isOpen ? close() : open();
            }

            function open() {
                button.classList.add('is--active');
                button.setAttribute('aria-expanded', 'true');
                submenu.classList.add('is--open');
                submenu.style.height = submenu.scrollHeight + 'px';
                // mainLink.setAttribute('tabindex', '0')
                sections.setVisible();
                isOpen = true;
            }

            function close() {
                button.classList.remove('is--active');
                button.setAttribute('aria-expanded', 'false');
                submenu.classList.remove('is--open');
                submenu.style.height = '';
                // mainLink.setAttribute('tabindex', '1')
                sections.setHidden();
                isOpen = false;
            }

            function initSections() {
                const sectionLinks = [].slice.apply(entry.querySelectorAll('.-sectionLink')),
                      sectionMenus = initSectionMenus();

                function initSectionMenus() {
                    return [].slice.apply(submenu.querySelectorAll('.-sectionMenu')).map(sectionMenu => {
                        const sectionBtn        = sectionMenu.querySelector('.-sectionMenu-button'),
                              sectionList       = sectionMenu.querySelector('.-sectionMenu-list'),
                              sectionEntries    = [].slice.apply(sectionList.querySelectorAll('.-sectionMenu-entry')),
                              sectionEntryLinks = sectionEntries.map(e => e.querySelector('.-sectionMenu-entry-link'));

                        let isSectionOpen = false;

                        sectionBtn.addEventListener('click', toggleSection);

                        if (sectionEntries.find(e => e.classList.contains('is--current'))) {
                            setTimeout(() => {
                                openSection();
                            }, 200);
                        }

                        function toggleSection() {
                            isSectionOpen ? closeSection() : openSection();
                        }

                        function openSection() {
                            sectionBtn.classList.add('is--active');
                            sectionBtn.setAttribute('aria-expanded', 'true');
                            sectionList.classList.add('is--open');
                            sectionList.style.height = sectionList.scrollHeight + 'px';
                            submenu.style.height = (submenu.scrollHeight + sectionList.scrollHeight) + 'px';
                            sectionEntryLinks.forEach(link => link.setAttribute('tabindex', '0'));
                            isSectionOpen = true;
                        }

                        function closeSection() {
                            sectionBtn.classList.remove('is--active');
                            sectionBtn.setAttribute('aria-expanded', 'false');
                            sectionList.classList.remove('is--open');
                            sectionList.style.height = '';
                            submenu.style.height = (submenu.scrollHeight - sectionList.scrollHeight) + 'px';
                            sectionEntryLinks.forEach(link => link.setAttribute('tabindex', '-1'));
                            isSectionOpen = false;
                        }

                        return {
                            el: sectionMenu,
                            button: sectionBtn,
                            toggle: toggleSection,
                            open: openSection,
                            close: closeSection,
                        };
                    });
                }

                function setVisible() {
                    sectionLinks.forEach(link => {
                        link.setAttribute('tabindex', '0');
                    });
                    sectionMenus.forEach(({ button }) => {
                        button.setAttribute('tabindex', '0');
                    });
                }

                function setHidden() {
                    sectionLinks.forEach(link => {
                        link.setAttribute('tabindex', '-1');
                    });
                    sectionMenus.forEach(({ button }) => {
                        button.setAttribute('tabindex', '-1');
                    });
                }

                return {
                    menus: sectionMenus,
                    setVisible,
                    setHidden,
                };
            }

            return {
                el: entry,
                toggle,
                open,
                close,
            };
        });

        function closeAll() {
            entries.forEach(entry => entry.close());
        }

        return {
            entries,
            closeAll,
        };
    }

    function toggleLogin() {
        document.dispatchEvent(new Event('rb.login.toggle'));
    }

    document.addEventListener('rb.login.shown', () => {
        hideMenu();
        loginOpen = true;
    });

    document.addEventListener('rb.login.hidden', () => {
        loginOpen = false;
    });

    document.body.addEventListener("focusin", (e) => {
        if (!(mainMenu.contains(e.target) || menuBtn.contains(e.target))) {
            hideMenu();
        }
    });

    root.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            hideMenu();
            hideSidebar();
        }
    });

    function toggleMenu() {
        menuOpen ? hideMenu() : showMenu();
    }

    function showMenu() {
        hideSearch();
        menuBtn.classList.add('is-active');
        menuBtn.classList.add('is--active');
        menuBtn.setAttribute('aria-expanded', 'true');
        menuBtn.setAttribute('aria-label', 'Stäng menyn');
        mainMenu.classList.add('is--visible');
        mainMenu.removeAttribute('inert');
        header.root.classList.add('is--menu-opened');
        prevPageYOffset = window.pageYOffset;
        menuOpen = true;
        sidebarToggler.inert = true;
    }

    function hideMenu() {
        menuBtn.classList.remove('is-active');
        menuBtn.classList.remove('is--active');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.setAttribute('aria-label', 'Öppna menyn');
        mainMenu.classList.remove('is--visible');
        mainMenu.setAttribute('inert', '');
        header.root.classList.remove('is--menu-opened');
        maybeScrollBack();
        menuOpen = false;
        sidebarToggler.inert = false;
    }


    function toggleSearch() {
        searchOpen ? hideSearch() : showSearch();
    }

    function showSearch() {
        hideMenu();
        searchBtn.classList.add('is--active');
        prevPageYOffset = window.pageYOffset;
        searchOpen = true;
    }

    function hideSearch() {
        searchBtn.classList.remove('is--active');
        maybeScrollBack();
        searchOpen = false;
    }

    function toggleSidebar() {
        sidebar.classList.contains('is--open') ? hideSidebar() : showSidebar();
    }

    function showSidebar() {
        sidebar.classList.add('is--open');
        sidebarToggler.classList.add('is-active');
        sidebarToggler.setAttribute('aria-expanded', 'true');
        sidebarToggler.setAttribute('aria-label', 'Stäng undermeny');
    }

    function hideSidebar() {
        sidebar.classList.remove('is--open');
        sidebarToggler.classList.remove('is-active');
        sidebarToggler.setAttribute('aria-expanded', 'false');
        sidebarToggler.setAttribute('aria-label', 'Öppna undermeny');
    }

    function haltAutoHide() {
        if (autohideAF) {
            window.cancelAnimationFrame(autohideAF);
        }
    }

    function maybeScrollBack() {
        if (prevPageYOffset != null) {
            window.scrollTo({
                top: prevPageYOffset,
                left: 0,
                behavior: 'auto',
            });
        }
        prevPageYOffset = null;
    }

    function initAutoHide() {
        let prevYOffset        = window.pageYOffset,
            lowerEdgeOffset    = root.offsetTop + 100,
            diff               = 0,
            scrollUpDistance   = 0,
            scrollDownDistance = 0;

        autohideAF = window.requestAnimationFrame(animate);

        function animate() {
            diff = window.pageYOffset - prevYOffset;
            if (diff < window.innerHeight && window.pageYOffset !== prevYOffset) {
                if (diff > 0) {
                    // Scroll down
                    scrollDownDistance += diff;
                    scrollUpDistance = 0;
                    if (!hidden && window.pageYOffset > lowerEdgeOffset && scrollDownDistance > 50 && !(searchOpen || menuOpen || loginOpen)) {
                        root.classList.add('is--hidden');
                        document.body.classList.add('is--header--hidden');
                        hidden = true;
                    }
                } else {
                    scrollUpDistance += -diff;
                    scrollDownDistance = 0;
                }
                if (hidden && scrollUpDistance > 150 || window.pageYOffset < lowerEdgeOffset) {
                    root.classList.remove('is--hidden');
                    document.body.classList.remove('is--header--hidden');
                    hidden = false;
                }
                prevYOffset = window.pageYOffset;
            }
            autohideAF = window.requestAnimationFrame(animate);
        }
    }
}
